import Header from "./Header";
import Footer from "./Footer";

export default function Layout({ children, overHero = false }) {
  return (
    <div className="min-h-screen bg-ivory">
      <Header overHero={overHero} />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
